export const KUSTOMER_SUBDOMAIN_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

/**
 * Accept an org slug, Kustomer hostname, or full URL and return the canonical
 * lowercase first DNS label used by machine as org_name.
 */
export const normalizeKustomerSubdomain = (value: string): string => {
	const trimmed = value.trim().toLowerCase();
	if (!trimmed) return '';
	if (KUSTOMER_SUBDOMAIN_PATTERN.test(trimmed)) return trimmed;

	try {
		const hasScheme = /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed);
		const url = new URL(hasScheme ? trimmed : `https://${trimmed}`);
		const labels = url.hostname.split('.');
		if (
			(url.protocol !== 'https:' && url.protocol !== 'http:') ||
			url.username ||
			url.password ||
			url.port ||
			labels.length !== 3 ||
			labels[1] !== 'kustomerapp' ||
			labels[2] !== 'com' ||
			!KUSTOMER_SUBDOMAIN_PATTERN.test(labels[0] ?? '')
		) {
			return trimmed;
		}
		return labels[0] ?? trimmed;
	} catch {
		return trimmed;
	}
};
